<template>
  <div class="header_main">
    <b-navbar toggleable="lg" type="dark" variant="dark"  :class="['fixed-top', {'is_show_menu': isShowMenu}]"
              v-if="$store.state.user !== null && $store.state.user.id !== undefined">
      <div class="container">
        <div class="header_burger_block" @click="$store.commit('handleBurger');"><ul :class="['menu-btn', {'expanded': $store.state.burgerExpanded}]"><li class="btn-line"/><li class="btn-line"/><li class="btn-line"/></ul></div>
        <b-navbar-brand to="/" class='nav_band_logo'><img src="/assets/logo-white.png" class="d-inline-block align-top"></b-navbar-brand>
        <div class="toggle_outer_block">
          <b-navbar-toggle target="nav-collapse" @click="toggleShow">
            <template #default="{ expanded }"><div :class="['menu-btn', {'open': isShowMenu}]"><li class="btn-line"></li><li class="btn-line"></li><li class="btn-line"></li></div></template>
          </b-navbar-toggle>
          <b-navbar-brand class="nav_band_logo" to="/"><img src="/assets/logo-white.png" class="d-inline-block align-top"></b-navbar-brand>
          <div class="right_mobile_open_menu_block right_mobile_items">
            <button class="no_btn" @click="toggleNotification">
              <fragment v-if="!notificationOpen">
                <b-icon icon="bell" class="d-lg-inline"></b-icon>
                <b-badge v-if="isset_unwatched()" variant="danger"><div class="notify_dot"></div></b-badge>
              </fragment>
              <i v-else class="icon-close"></i>
            </button>
            <button class="no_btn" @click="toggleShow(true);$router.history.push('/settings/profile')">
              <img v-if="userPhoto" :src="userPhoto" class="img-thumbnail rounded-circle ava_nav_img"/>
              <b-icon v-else icon="person-circle" class="d-none d-lg-inline"></b-icon>
            </button>
          </div>
        </div>
        <b-collapse id="nav-collapse" is-nav class="notransition" ref="navCollapse">
          <section class="nav_left_section mb_dn"><header-menu-add-options/></section>
          <nav-path/>
          <div class="aside_mb_wrapper_block ds_dn"><Aside @toggle-show="toggleShow"/></div>
          <b-navbar-nav class="navbar_pay_nav">
            <li class="settings_theme_nav">
              <theme-light-svg/><b-checkbox switch :checked="$store.state.isDarkTheme" @change="changeTheme"/><theme-dark-svg/>
            </li>
            <b-nav-item to="/settings/profile" class="settings_profile_nav" @click="toggleShow">
              <span class="user_title">{{userTitle}}</span>
            </b-nav-item>
            <b-nav-item-dropdown no-caret right @hidden="hiddenNotifyDropDown" class="notify_drop_down">
              <template #button-content>
                <b-icon icon="bell" style="font-size: 18px;" class="d-none d-lg-inline"></b-icon>
                <b-badge v-if="isset_unwatched()" variant="danger"><div class="notify_dot"></div></b-badge>
              </template>
              <template #default>
                <div :class="['notify_main_content_block', {'not_notify': !notifications.length}]">
                  <div class="t_b"><article v-show="notifications.length">{{trans('common.Notifications')}}</article><button class="no_btn" @click.stop="watch_all()" v-if="notifications.length">{{trans('common.Clear', { nr: 'Очистить' })}}</button></div>
                  <div class="no_notification_main" v-if="!notifications.length"><p v-html="trans('common.No_notification')"></p></div>
                  <transition-group name="fade" tag="div" v-else class="notification_list">
                    <section v-for="(notification,i) in notifications" :key="notification.id">
                      <button class="no_btn notify_close_btn" @click="watch(notification)"><i class="icon-close"></i></button>
                      <article v-html="notification.text" v-b-tooltip.hover :title="notification.tooltip_text" v-b-tooltip.bottom v-b-tooltip="{ customClass: 'notify_tool_tip'}"></article>
                    </section>
                  </transition-group>
                </div>
              </template>
            </b-nav-item-dropdown>
            <b-nav-item @click="onLogout" class="mb-1"><log-out-svg/></b-nav-item>
          </b-navbar-nav>
        </b-collapse>
        <div class="mobile_right_container_block right_mobile_items">
          <button class="no_btn" @click="toggleNotification">
            <fragment v-if="!notificationOpen">
              <b-icon icon="bell" class="d-lg-inline"></b-icon>
              <b-badge v-if="isset_unwatched()" variant="danger"><div class="notify_dot"></div></b-badge>
            </fragment>
            <i v-else class="icon-close"></i>
          </button>
          <header-menu-add-options/>
          <b-nav-item-dropdown no-caret dropleft class="profile_drop_down m_b mb_dn">
            <template #button-content>
              <img v-if="userPhoto" :src="userPhoto" class="img-thumbnail rounded-circle ava_nav_img"/>
              <b-icon v-else icon="person-circle" class="d-lg-inline"></b-icon>
            </template>
            <b-dropdown-item @click="$router.push('/settings/profile')"><a role="button" href="#"><b-icon icon="person-circle" class="d-lg-inline"></b-icon>{{this.trans('common.Profile', { nr: 'Профиль' })}}</a></b-dropdown-item>
            <b-dropdown-item @click="onLogout" class="lt_dritm"><a role="button" href="#"><log-out-svg/>{{this.trans('common.Exit', { nr: 'Выход' })}}</a></b-dropdown-item>
          </b-nav-item-dropdown>
          <div class="open_menu_bottom_block">
            <b-nav-item
                v-if="$store.state.user.tests_count"
                to="/settings/subscribe/info"
                @click="toggleShow(true)"
            >
              {{this.trans('common.Tests', { nr: 'Тесты' })}}: {{ number_format($store.state.user.tests_count, 0, ' ', ' ') }}
            </b-nav-item>
            <span class="d-flex items-center">
              <b-nav-item to="/settings/profile"  @click="toggleShow(true)" class="mr-4">{{userTitle}}</b-nav-item>
              <a href="#" role="button" @click.prevent="onLogout"><log-out-svg/></a>
            </span>
          </div>
        </div>
      </div>
    </b-navbar>
    <transition name="slide-left-centered-2">
    <section :class="['notification_mobile_section', {'no_notification': !notifications.length}]" v-if="notificationOpen">
      <div class="notification_top_block"><article>{{this.trans('common.Notifications', { nr: 'Уведомления' })}}</article><button class="no_btn" @click.stop="watch_all()" v-if="notifications.length">{{this.trans('common.Clear', { nr: 'Очистить' })}}</button></div>
      <div class="no_notifications_block" v-if="!notifications.length"><p v-html="this.trans('common.No_notification', { nr: 'Новые уведомления отсутствуют' })"></p></div>
      <transition-group name="fade" tag="div" v-else class="notification_content_block">
        <section v-for="(notification, i) in notifications" :key="notification.id">
          <button class="no_btn notify_close_btn" @click="watch(notification)"><i class="icon-close"></i></button>
          <article v-html="notification.text" v-b-tooltip v-b-tooltip.hover :title="notification.tooltip_text"></article>
        </section>
      </transition-group>
    </section>
    </transition>
  </div>
</template>

<script>
import {debounce} from "../utils";
import LogOutSvg from "./common/svg/log-out-svg";
import CollapsePlus from "./common/collapse-plus.vue";
import NewPlusWhiteSvg from "./common/svg/new-plus-white-svg.vue";
import NavPath from "./common/nav-path.vue";
import HeaderMenuAddOptions from "./header-menu-add-options.vue";
import ThemeLightSvg from "./common/svg/theme-light-svg.vue";
import ThemeDarkSvg from "./common/svg/theme-dark-svg.vue";
import Aside from "../views/Aside.vue";

export default {
  name: "HeaderMenu",
  components: {
    Aside,
    ThemeDarkSvg, ThemeLightSvg, HeaderMenuAddOptions, NavPath, NewPlusWhiteSvg, CollapsePlus, LogOutSvg},
  data() {
    return {
      isShowMenu: false,
      notificationOpen: false,
      notifications: []
    }
  },
  computed: {
    isNavDisabled() {
      return (this.$store.getters.activeSubscribe === null && !this.$store.getters.getUserIsCustomer)
    },

    notChild() {
      return this.$store.getters.getUser?.is_child === false;
    },
    userTitle() {
      const {last_name, first_name, sur_name} = this.$store.getters.getUser;
      return [first_name, last_name].map((n,i) => n?.length && i !== 0 ? `${n.slice(0,1).toUpperCase()}.` : n).filter(n => n !== null).join(' ')
    },
    userPhoto() {
      const {photo} = this.$store.getters.getUser || {}
      return photo !== null ? 'https://storage.hr-crm.io/users_photos/'+photo : null;
    },
    popUpTitle() {
      return (section = '') => {
        if(!this.$store.getters.getUser.is_child && section === 'settings') return '';
        if(this.$store.getters.getUser.is_access_analytics && section === 'analytics') return '';
        return this.isNavDisabled ? 'Раздел станет доступен после оформления подписки' : ''
      }

    },
    get_unwatched_count() {
      let unwatched = [];
      this.notifications.forEach(function (notification) {
        if (notification.is_view == null) unwatched.push(notification);
      });
      return unwatched.length;
    },
  },
  watch: {
    isDarkTheme(val){

      }
  },
  methods: {
    changeTheme(payload) {
      const theme = payload ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
      this.$store.commit('setFunction', {payload, name: 'isDarkTheme'})
    },
    readMessagesRequest(applicant_id) {
      return this.$http.post(`/api/chat/messages/read/${applicant_id}`, {})
    },
    backToHome() {
      window.location.href = '/'
    },
    backToAdmin() {
      window.location.href = '/api/users/back-to-admin/' + $cookies.get('login_hash')
    },
    toggleShow(outer = false) {
      if(this.notificationOpen) this.notificationOpen = false
      if(this.$store.state.isMobWidth) this.isShowMenu = !this.isShowMenu
      if(this.$refs.navCollapse.show && outer === true) {
        this.$refs.navCollapse.show = false;
      }
    },
    toggleNotification(){
      if(this.isShowMenu) {this.isShowMenu = this.$refs.navCollapse.show = false}
      this.notificationOpen = !this.notificationOpen;
      if(!this.notificationOpen) this.get_notifications();
    },
    hiddenNotifyDropDown() {
      this.get_notifications();
    },
    isset_unwatched() {
      let flag = false;
      this.notifications.forEach(function (notification) {
        if (notification.is_view == null) flag = true;
      });
      return flag;
    },
    get_notifications() {
      this.$http.get('/api/notifications/get?type=1').then(response => {
        this.notifications = response.data;
      });
    },
    watch: debounce(function ({id}) {
      this.$http.get('/api/notifications/watch', {params: {notification_id: id}});
      this.notifications = this.notifications.filter(n => n.id !== id)
    }, 100),
    watch_all() {
      this.$http.get('/api/notifications/watch-all');
      this.notifications = [];
    },
    availableUser(user_id) {
      this.get_notifications();
      this.$echo.private(`Notification.${user_id}`).listen('.NotifyCreated', (n) => {this.get_notifications();});
      this.$echo.private(`ApplicantMessage`).listen('.MessageCreated', this.subscribeMessageListener)
      this.getUserSummary();
    },
    subscribeMessageListener(message) {
      this.$store.state.chatIsRead && debounce(this.$store.dispatch('checkChatOnNew'), 2000)
      this.$bus.$emit('newMessageEmmit', message)
    },
    getUserSummary() {
      return window.http.get('/api/apps/user-summary').then(({data}) => {
        this.$store.commit('updateUser', {apps_info: data})
      })
    },
    onLogout() {
      this.$store.commit('openModalConfirm',
          {title: 'Подтверждение выхода',
            desc: `Точно выходим из системы?`,
            ok_emit: 'logoutEmmit',
          })

    },
    logout() {
      window.location.href = '/logout'
    },
    applicantReadChat(applicant_id) {
      this.readMessagesRequest(applicant_id).then(this.$store.dispatch('checkChatOnNew'))
    },
    handleChatOnNew() {
      this.$store.dispatch('checkChatOnNew')
    }
  },
  mounted() {
    // subscribe to channels
    if (!this.$store.getters.getUserId) this.$bus.$on('availableUser', this.availableUser)
    else this.availableUser(this.$store.getters.getUserId)
    this.$bus.$on('logoutEmmit', this.logout)
    this.$bus.$on('checkChatOnNewEmmit', this.handleChatOnNew)
    this.$bus.$on('applicantReadChatEmmit', this.applicantReadChat)
    this.subscribe = this.$store.subscribe(
        ({type, payload}) => {
          if (type === 'setUserInfo' && payload?.id) {
            this.$bus.$emit('availableUser', payload.id);
            this.$bus.$emit('checkChatOnNewEmmit')
          }
        })
  },
  beforeDestroy() {
    this.$bus.$off('logoutEmmit', this.logout)
    this.$bus.$off('checkChatOnNewEmmit',  this.handleChatOnNew)
    this.$bus.$off('applicantReadChatEmmit', this.applicantReadChat)
    this.$echo.leave(`ApplicantMessage`)
  }
}
</script>

<style>
  .header_main > nav > .container {max-width: 100% !important;}
  .header_main > .navbar {padding: 0;}
  .header_burger_block {margin-left: 14px;}
  .header_burger_block > ul.menu-btn {width: 18px; height: 14px; top: 2px}
  .header_burger_block ul.menu-btn li {height: 2px;}
  .header_burger_block ul.menu-btn li:nth-child(1) {top: -1px;}
  .header_burger_block ul.menu-btn li:nth-child(2) {top: 4px;}
  .header_burger_block ul.menu-btn li:nth-child(3) {top: 9px;}
  .header_burger_block ul.menu-btn.expanded li:nth-child(3) {left: 4px;top: 11px;-webkit-transform: rotate(-45deg);-moz-transform: rotate(-45deg);-o-transform: rotate(-45deg);transform: rotate(-45deg);}
  .header_burger_block ul.menu-btn.expanded li:nth-child(2) {opacity: 0;width: 0;}
  .header_burger_block ul.menu-btn.expanded li:nth-child(1) {left: 4px;top: -2px;-webkit-transform: rotate(45deg);-moz-transform: rotate(45deg);-o-transform: rotate(45deg);transform: rotate(45deg);}

  .ava_nav_img {width: 32px !important; height: 32px !important; object-fit: cover;}
  .header_main .red_txt {color: red;}
  .header_main #nav-collapse > .nav_left_section {margin-left: 116px;}

  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) { display: flex; flex: 1; justify-content: flex-end; }
  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li.dropdown > a:after {vertical-align: middle; margin-left: 12px;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li > a.active::after, .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li.active > a:before {display: block; position: absolute; content: ''; -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg); -o-transform: skew(-20deg); background: #2591CB; top: 0; left: 0; right: 0; bottom: 0; z-index: -100;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li > a.active, .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li.active > a {color: #ffffff; font-weight: 700; font-size: 14px;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li > a {color: #FFFFFF; padding: 2px 4px; position: relative; display: block;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li > a:hover {color: #ffffff}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li:nth-of-type(3) {margin-bottom: 2px;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li:not(:last-child) { }
  .header_main > .fixed-top > .container > a.navbar-brand { margin-right: 0; height: 30px; padding: 0; margin-left: 24px;}
  .header_main .navbar-brand {margin-right: 0; width: 140px; height: 30px;}
  .header_main .profile_drop_down a {color: var(--p-blue)}
  .header_main > .fixed-top > .container > a > img { height: 100%; }
  .header_main > nav {background: var(--System-Header-bg, #161A1D) !important; }
  @media (min-width: 992px) { .header_main > nav { height: 56px; } }
  .header_main .user_title { display: flex; align-items: center; font-size: 14px; font-weight: 400; color: #FFFFFF; margin: 0 6px 0 10.5px;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(2) > li > a {padding: 0; color: #FFFFFF;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(2) > li > a:nth-child(1) { display: block; position: relative;}
  .header_main #nav-collapse > .navbar-nav:nth-of-type(2) > li > a:nth-child(1) .badge-danger {position: absolute; width: 12px; height: 12px; right: -3px; border: 2px solid #2C343C;
    border-radius: 50%; display: block; padding: 0; bottom: 2px; }
  .header_main .settings_profile_nav > a {display: flex !important; align-items: center;}
  .header_main .navbar_pay_nav {align-items: center; font-size: 14px;}
  /*mob*/
  .header_main .right_mobile_items {display: none;}
  .header_main .toggle_outer_block > .navbar-brand, .header_main .toggle_outer_block > .right_mobile_open_menu_block {display: none}
  .header_main .nav_band_logo {padding: 0 !important; width: 140px; height: 100%;}
  .header_main .nav_band_logo > img {height: 100%;}
  .header_main .open_menu_bottom_block { display: none;}
  /*dropdown profile*/
  .header_main .profile_drop_down > .dropdown-menu {top: 44px; right: 0;}
  .header_main .profile_drop_down.m_b > .dropdown-menu {top: 48px;}
  .header_main .profile_drop_down > .dropdown-menu .dropdown-item > a > svg > path {fill: var(--p-blue)}
  .header_main .profile_drop_down > .dropdown-menu .dropdown-item > a > svg {margin-right: 8px;}
  .header_main .profile_drop_down > .dropdown-menu .dropdown-item > a {display: flex; align-items: center;}
  .header_main .profile_drop_down > .dropdown-menu .lt_dritm > .dropdown-item > a > svg {width: 20px; position: relative; left: -2px;}
  .header_main .settings_theme_nav {display: flex; align-items: center;}
  .header_main .settings_theme_nav > svg:last-child {margin-top: -6px; margin-left: 2px;}
  .header_main .settings_theme_nav > svg:first-child {margin-right: 10px;}
  /*notification*/
  .header_main .notification_mobile_section {position:fixed; top: 50px; bottom: 0; left: 0; right: 0; background: #2C343C; z-index: 2000;  padding: 16px;}
  .header_main .notification_mobile_section > .notification_top_block {display:flex; justify-content: space-between; align-items: center; margin-bottom: 16px;}
  .header_main .notification_mobile_section.no_notification > .notification_top_block {justify-content: center;}
  .header_main .notification_mobile_section > .notification_top_block > article {font-weight: 700; font-size: 16px; color: #FFFFFF;}
  .header_main .notification_mobile_section > .notification_top_block > button {color: var(--p-blue); font-weight: 500; font-size: 12px;}
  .header_main .notification_mobile_section > .no_notifications_block {min-height: 80px; display: flex; justify-content: center; align-items: center;}
  .header_main .notification_mobile_section > .no_notifications_block > p {color: #C7E5F5; font-weight: 500; font-size: 14px; text-align: center;}
  .header_main .notification_content_block {overflow-y: auto;}
  .header_main .notification_content_block > section:not(:last-child) {margin-bottom: 8px;}
  .header_main .notification_content_block > section {background: var(--System-card-bg); opacity: 0.98; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.24);border-radius: 4px; padding: 20px 16px 16px; position: relative;}
  .header_main .notification_content_block > section > .notify_close_btn {display: block; position: absolute; height: 24px; width: 24px;
    border-radius: 50%; top: 0; right: 0;}
  .header_main .notification_content_block > section > .notify_close_btn > i {position: absolute; transform: translate(-50%, -50%); top: 50%; left: 50%; height: 24px;}
  .header_main .notification_content_block > section > .notify_close_btn > i:before {font-size: 8px; color: var(--p-blue);}
  .header_main .notification_content_block > section > article {color: var(--System-Text); font-size: 14px;  white-space:pre-wrap;word-break:break-word;}
  .header_main .notification_content_block > section > article > a, .header_main .notification_content_block > section > article > span {color: var(--p-blue)}
  .notify_tool_tip .tooltip-inner {max-width: 400px; width: 400px}
  .header_main > nav > .container > .mobile_right_container_block > .header_menu_add_options {display: none;}
  @media (max-width: 992px) {
    .header_main > nav > .container > .mobile_right_container_block > .header_menu_add_options {display: block;}
    .header_burger_block {display: none;}
    .header_main > .navbar {}
    .header_main > nav > .container {flex-wrap: nowrap}
    .header_main > .fixed-top > .container > a.navbar-brand {position: absolute;transform: translateX(-50%); left: 50%; text-align: center; margin-left: 0;}
    .header_main > nav > .container > .navbar-brand {order: 2; width: 140px; height: 30px;}
    .header_main > nav > .container > .toggle_outer_block .navbar-toggler {color: #FFFFFF; border-color: transparent; margin-right: 18px;}
    .header_main > nav > .container > .mobile_right_container_block {display: flex; align-items: center; margin-right: 16px;  order: 3}
    .header_main > nav > .container > .mobile_right_container_block > .nav-item {display: flex; align-items: center;}
    .header_main > nav > .container > .mobile_right_container_block > .nav-item > a {color: #FFFFFF; padding: 0;}
    .header_main > nav > .container > .mobile_right_container_block > .nav-item::marker {display: none;}
    .header_main > nav > .container > .mobile_right_container_block .settings_profile_nav {width: 20px; height: 20px;}

    /*nav collapse*/
    .header_main > .navbar.is_show_menu > .container > #nav-collapse {display: flex !important;}
    #nav-collapse {width: 100%; flex-direction: column; align-items: stretch;}
    .header_main > .navbar:not(.is_show_menu) > .container > #nav-collapse {display: none;}
    .aside_mb_wrapper_block {flex: 1 1;}
    .header_main .settings_theme_nav {flex: 1 1;}
    .header_main #nav-collapse > .navbar-nav:nth-of-type(1) {flex-direction: row; flex: 0; padding: 8px 16px;}
    .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li > a {font-size: 16px; font-weight: 700; color: #FFFFFF;}
    .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li:not(:last-child) {margin-bottom: 0;}
    .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li > a.active {color: var(--p-blue)}
    .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li > a.active::after, .header_main #nav-collapse > .navbar-nav:nth-of-type(1) > li.active > a:before {display: none;}
    #nav-collapse > .navbar_pay_nav {background: var(--System-Header-bg);}
    .header_main > nav.is_show_menu > .container > .navbar-brand {display: none; width: 140px; height: 30px;}
    .header_main > nav:not(.is_show_menu) {min-height: 50px }
    .header_main > nav.is_show_menu {}
    .header_main > nav.is_show_menu > .container {justify-content: flex-start; align-items: flex-start; flex-direction: column; flex-wrap: nowrap; background: var(--System-Beige); height: 100vh;
    max-height: 100vh; overflow-y: scroll;}
    .header_main > nav.is_show_menu > .container > .mobile_right_container_block {display: none;}
    .header_main > nav.is_show_menu .toggle_outer_block {display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 8px 0; background: var(--System-Header-bg)}
    .header_main > nav.is_show_menu .toggle_outer_block > .navbar-brand {display: block; width: 140px; height: 30px; text-align: center; position: absolute; left: 50%; transform: translateX(-50%)}
    .header_main > nav.is_show_menu .toggle_outer_block > .right_mobile_open_menu_block {display: flex; align-items: flex-end; margin-right: 8px;}
    .header_main .right_mobile_items {display: flex; align-items: center; min-width: 74px; justify-content: space-between}
    .header_main .right_mobile_items > button > *, .header_main .right_mobile_items > button > i:before {color: #FFFFFF;}
    .header_main .right_mobile_items > button:first-child {display: block; position: relative; padding: 4px; margin-right: 6px;}
    .header_main .right_mobile_items > button:first-child i.icon-close:before {vertical-align: middle;}
    .header_main .right_mobile_items > button:first-child .badge-danger {position: absolute;width: 12px;height: 12px;right: -3px;border: 2px solid #2C343C;border-radius: 50%;display: block;padding: 0;bottom: 2px;}
    .header_main > nav.is_show_menu .mobile_right_container_block.right_mobile_items > button.no_btn,
    .header_main > nav.is_show_menu .mobile_right_container_block.right_mobile_items > .b-nav-dropdown {display: none;}
    .header_main > nav.is_show_menu .open_menu_bottom_block { display: flex; align-items: center; justify-content: space-between; width: 100%;}
    .header_main > nav.is_show_menu .open_menu_bottom_block a {color: #FFFFFF; font-size: 14px; padding: 0;}
    .header_main > nav.is_show_menu .open_menu_bottom_block > span {line-height: 25px;}
    .header_main > nav.is_show_menu .open_menu_bottom_block > span > a {position: relative; bottom: 1.5px;}
    .header_main > nav.is_show_menu .open_menu_bottom_block .nav-item {display: flex; padding: 0;}
    /*notification*/
    .header_main .notification_mobile_section {display: flex; flex-direction: column;}
    .header_main .notification_mobile_section.open {visibility: visible; opacity: 1;}
  }

  .menu-btn {cursor: pointer;height: 24px;list-style: none;margin: 0 0 0 auto;padding: 0;width: 30px;position: relative;top: 3px;-webkit-transform: rotate(0deg);-moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);transform: rotate(0deg);-webkit-transition: .3s ease-in-out;-moz-transition: .3s ease-in-out;-o-transition: .3s ease-in-out;transition: .3s ease-in-out;}
  .menu-btn li {background-color: #FFFFFF;border-radius: 4px;display: block;height: 3px;left: 0;margin: 0;opacity: 1;padding: 0;position: absolute;width: 100%;-webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);-o-transform: rotate(0deg);transform: rotate(0deg);-webkit-transition: .15s ease-in-out;-moz-transition: .15s ease-in-out;-o-transition: .15s ease-in-out;transition: .15s ease-in-out;}
  .menu-btn li:nth-child(1) {top: -1px;-webkit-transform-origin: left center;-moz-transform-origin: left center;-o-transform-origin: left center;transform-origin: left center;}
  .menu-btn li:nth-child(2) {top: 9px;-webkit-transform-origin: left center;-moz-transform-origin: left center;-o-transform-origin: left center;transform-origin: left center;}
  .menu-btn li:nth-child(3) {top: 18px;-webkit-transform-origin: left center;-moz-transform-origin: left center;-o-transform-origin: left center;transform-origin: left center;}
  .menu-btn.open li:nth-child(3) {left: 4px;top: 20px;-webkit-transform: rotate(-45deg);-moz-transform: rotate(-45deg);-o-transform: rotate(-45deg);transform: rotate(-45deg);}
  .menu-btn.open li:nth-child(2) {opacity: 0;width: 0;}
  .menu-btn.open li:nth-child(1) {left: 4px;top: -1px;-webkit-transform: rotate(45deg);-moz-transform: rotate(45deg);-o-transform: rotate(45deg);transform: rotate(45deg);}

  .notify_drop_down .dropdown-menu {padding: 24px 16px !important; border-radius: 8px; background: #2C343C; top: 40px; flex-direction: column}
  .notify_drop_down .dropdown-menu.show {display: flex !important;}
  .notify_drop_down .notify_main_content_block {width: 432px; display: flex; flex-direction:  column; flex: 1 1;}
  .notify_drop_down .notify_main_content_block > .notification_list::-webkit-scrollbar {height: 6px;width: 4px;background: #000;}
  .notify_drop_down .notify_main_content_block > .notification_list::-webkit-scrollbar-thumb {background: #6E7D8A;-webkit-border-radius: 1ex;-webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);}
  .notify_drop_down .notify_main_content_block > .notification_list::-webkit-scrollbar-corner {background: #000;}
  .notify_drop_down .notify_main_content_block > .t_b {display: flex; justify-content: space-between; align-items: center;}
  .notify_drop_down .notify_main_content_block:not(.not_notify) > .t_b {margin-bottom: 16px;}
  .notify_drop_down .notify_main_content_block > .t_b > article {color: #FFFFFF; font-weight: 700; font-size: 16px;}
  .notify_drop_down .notify_main_content_block > .t_b > button {font-weight: 500;font-size: 12px;line-height: 16px; color: #2591CB;}
  .notify_drop_down .notify_main_content_block > .no_notification_main {height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; flex: 1 1;}
  .notify_drop_down .notify_main_content_block > .no_notification_main > p {margin: 0; text-align: center; color: #C7E5F5; font-size: 14px; font-weight: 500;}
  .notify_drop_down .notify_main_content_block > .notification_list {display: flex; flex-direction: column; overflow-y: auto; max-height: 616px;}
  .notify_drop_down .notify_main_content_block > .notification_list > section:first-child {margin-top: 8px;}
  .notify_drop_down .notify_main_content_block > .notification_list > section {background: var(--System-card-bg); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.24); border-radius: 4px; font-size: 14px; padding: 16px; position: relative; margin-right: 8px;}
  .notify_drop_down .notify_main_content_block > .notification_list > section > .notify_close_btn {display: none; position: absolute; height: 24px; width: 24px; background: var(--System-Grey-7); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.24);
    border-radius: 50%; top: -8px; right: -8px;}
  .notify_drop_down .notify_main_content_block > .notification_list > section > .notify_close_btn:hover > i:before {font-weight: 700;}
  .notify_drop_down .notify_main_content_block > .notification_list > section > .notify_close_btn > i {position: absolute; transform: translate(-50%, -50%); top: 50%; left: 50%; height: 24px;}
  .notify_drop_down .notify_main_content_block > .notification_list > section > .notify_close_btn > i:before {font-size: 8px; color: var(--p-blue);}
  .notify_drop_down .notify_main_content_block > .notification_list > section:hover {background: var(--System-Grey-7);}
  .notify_drop_down .notify_main_content_block > .notification_list > section:hover > .notify_close_btn {display: block;}
  .notify_drop_down .notify_main_content_block > .notification_list > section > article {overflow: hidden; text-overflow: ellipsis; line-height: 16px; word-break: break-all;
    display: -webkit-box; -webkit-box-orient: vertical; font-size: 14px; -webkit-line-clamp: 3;  white-space:pre-wrap; word-break:break-word;}
  .notify_drop_down .notify_main_content_block > .notification_list > section > article > a, .notify_drop_down .notify_main_content_block > .notification_list > section > article > span {color: var(--p-blue)}
  .notify_drop_down .notify_main_content_block > .notification_list > section:not(:last-child) {margin-bottom: 8px;}
  .chat_nav_item {position: relative;}
  .chat_nav_item .badge-danger {background-color: transparent; position: absolute}
  .chat_nav_item .badge-danger > .notify_dot {position: absolute; width: 6px;height: 6px; right: -23px; top: 1px; background-color: #dc3545; border-radius: 50%;}
</style>
